import React from "react";
import { useNavigate } from "react-router-dom";
import { Phone, Shield, LogOut, CreditCard } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { StatusBadge } from "@/components/StatusBadge";

export default function Account() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  return (
    <div className="max-w-xl mx-auto" data-testid="account-page">
      <p className="vw-label">Account</p>
      <h1 className="font-display text-2xl sm:text-3xl font-bold text-white mt-1 mb-6">Your Account</h1>

      <div className="vw-card p-6 space-y-5">
        <Row icon={Phone} label="Phone number" value={user?.phone} />
        <Row icon={Shield} label="Account status" value={<StatusBadge status={user?.status} />} />
        <Row icon={CreditCard} label="Member since" value={user?.created_at ? new Date(user.created_at).toLocaleDateString() : "—"} />
      </div>

      <button onClick={() => { logout(); navigate("/"); }} className="vw-btn-outline w-full mt-6 !py-3.5 inline-flex items-center justify-center gap-2 hover:!border-red-500/50 hover:!text-red-400" data-testid="account-logout">
        <LogOut size={18} /> Logout
      </button>
    </div>
  );
}

const Row = ({ icon: Icon, label, value }) => (
  <div className="flex items-center justify-between gap-4">
    <div className="flex items-center gap-3 text-slate-400">
      <Icon size={18} className="text-emerald-400" /> <span className="text-sm">{label}</span>
    </div>
    <div className="text-white font-medium">{value}</div>
  </div>
);
